module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-949-retro-min.cac30476.jpg";